var render, staticRenderFns
import script from "./RemoteNewsroomItem.vue?vue&type=script&lang=js&"
export * from "./RemoteNewsroomItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15469339')) {
      api.createRecord('15469339', component.options)
    } else {
      api.reload('15469339', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/Newsroom/Components/Remote/RemoteNewsroomItem.vue"
export default component.exports